import React from 'react';
import { Tab } from '../types';
import { Calendar, ShieldCheck, Users } from 'lucide-react';

interface NavigationProps {
  activeTab: Tab;
  setActiveTab: (tab: Tab) => void;
}

const Navigation: React.FC<NavigationProps> = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { id: Tab.ADVENT, label: 'ADVENT CALENDAR', icon: Calendar },
    { id: Tab.PROOF, label: 'PROOF BOARD', icon: ShieldCheck },
    { id: Tab.SUGGESTIONS, label: 'COMMUNITY SUGGESTIONS', icon: Users },
  ];

  return (
    <div className="w-full max-w-4xl mx-auto px-4 mb-8">
      <div className="flex flex-col sm:flex-row justify-center items-center bg-zinc-900/50 backdrop-blur-sm p-1.5 rounded-2xl border border-zinc-800">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                relative flex items-center justify-center gap-2 px-6 py-3 w-full sm:w-auto rounded-xl text-sm font-bold transition-all duration-300
                ${isActive 
                  ? 'text-black shadow-lg' 
                  : 'text-gray-400 hover:text-white hover:bg-white/5'
                }
              `}
            >
              {isActive && (
                <div className="absolute inset-0 bg-christmas-gold rounded-xl shadow-[0_0_15px_rgba(248,178,41,0.5)]" />
              )}
              <span className="relative z-10 flex items-center gap-2">
                <Icon size={16} className={isActive ? 'text-black' : ''} />
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Navigation;